import React, { useEffect, useState } from "react";
// import ModalDiagram from "../misc/ModalDiagram";
// import IntegrationDataMappingDiagram from "./IntegrationDataMappingDiagram";

// import dynamic from "next/dynamic";

import { ReactFlowProvider } from "reactflow";
import DataMappingDiagram from "./DataMappingDiagram";


const DataMapping = ({ details, onButtonClick, onMappingAdded }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownMethod, setShowDropdownMethod] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const onMappingAddedInChild = (mappings) => {
    // console.log("onMappingAddedInChild....", mappings);
    if (onMappingAdded) {
      onMappingAdded(mappings);
    }
  };
  

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 100);
  }, []);

  const onClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
  };

  const onDropDown = () => {
    setShowDropdown(!showDropdown);
  };

  const onDropDownMethod = () => {
    setShowDropdownMethod(!showDropdownMethod);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="mb-6  pt-4 h-[calc(100vh-140px)]">
      <div className="text-sm">
        <div className="text-gray-600">
          <div className="flex h-[90%] w-full items-center justify-between text-white">
            <div>
              <span className="text-lg font-medium">Data Mapping</span>
              <span> - Map Source and Destination fields.</span>
            </div>
            {/* <div>
              <button
                onClick={openModal}
                className="mt-4 rounded-md bg-blue-200 px-4 py-2 text-gray-800 hover:bg-blue-400"
              >
                Edit Mapping Diagram
              </button>
            </div> */}
          </div>
          {loaded && (
            <ReactFlowProvider>
              <DataMappingDiagram  details={details} interactive={true} onMappingsAdded={onMappingAddedInChild} />
            </ReactFlowProvider>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataMapping;
